import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import WheelOfFortunePopup from "@/components/popups/WheelOfFortunePopup.vue";
import InternalStorePopup from "@/components/popups/InternalStorePopup.vue";
import SelectGameToPlayPopup from "@/components/popups/SelectGameToPlayPopup.vue";
import {ref} from "vue";
import LootboxPopup from "@/components/popups/LootboxPopup.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Popups',
  setup(__props, { expose: __expose }) {

const popups = {
  wheelOfFortunePopup: ref<InstanceType<typeof WheelOfFortunePopup> | null>(null),
  internalStorePopup: ref<InstanceType<typeof InternalStorePopup> | null>(null),
  selectGameToPlayPopup: ref<InstanceType<typeof SelectGameToPlayPopup> | null>(null),
  lootboxPopup: ref<InstanceType<typeof LootboxPopup> | null>(null),
}

const getPopups = () => {
  return popups;
}
__expose({ getPopups })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SelectGameToPlayPopup, {
      ref: (el) => popups.selectGameToPlayPopup = el
    }, null, 512),
    _createVNode(LootboxPopup, {
      ref: (el) => popups.lootboxPopup = el
    }, null, 512),
    _createVNode(InternalStorePopup, {
      ref: (el) => popups.internalStorePopup = el
    }, null, 512),
    _createVNode(WheelOfFortunePopup, {
      ref: (el) => popups.wheelOfFortunePopup = el
    }, null, 512)
  ]))
}
}

})